/** Global loading signal with pub/sub pattern and trailing hold */

type Listener = (isLoading: boolean) => void;

const activeKeys = new Set<string>();
const listeners = new Set<Listener>();
let trailTimer: ReturnType<typeof setTimeout> | null = null;
let reported = false; // last state broadcast to listeners

function notify(loading: boolean) {
  if (reported === loading) return;
  reported = loading;
  listeners.forEach((fn) => fn(loading));
}

export function setLoading(key: string, loading: boolean) {
  if (loading) {
    activeKeys.add(key);
    if (trailTimer) {
      clearTimeout(trailTimer);
      trailTimer = null;
    }
    notify(true);
  } else {
    activeKeys.delete(key);
    if (activeKeys.size === 0) {
      // 800ms trailing hold — outlast skeleton screens
      if (!trailTimer) {
        trailTimer = setTimeout(() => {
          trailTimer = null;
          if (activeKeys.size === 0) notify(false);
        }, 800);
      }
    }
  }
}

export function getIsLoading(): boolean {
  return reported;
}

export function subscribeLoading(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
